import React from 'react';
import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { BookingSummarySection } from './BookingSummarySection';

interface IOriginalAndNewTotalProps {
	originalTotalPrice: IPrice;
	totalPrice: IPrice;
}

export const OriginalAndNewTotal = ({
	originalTotalPrice,
	totalPrice,
}: IOriginalAndNewTotalProps) => {
	const { t } = useTranslation();

	return (
		<>
			<BookingSummarySection
				title={t('web_parking_booking_summary_old_total')}
				price={originalTotalPrice}
			/>
			<BookingSummarySection
				title={t('web_parking_booking_summary_new_total')}
				price={totalPrice}
			/>
		</>
	);
};
